import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeNotify } from './notify.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'ACTIONS_INDEX',
    LOADING: 'ACTIONS_LOADING',
    COUNT: 'ACTIONS_COUNT',
    CHANGE: 'ACTIONS_CHANGE',
    SUCCESS: 'ACTIONS_SUCCESS',
    ERROR: 'ACTIONS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const loadingResponse = (payload) => ({
    type: actionTypes.LOADING,
    payload
})

// COUNT

export const countResponse = (payload, action_id) => ({
    type: actionTypes.COUNT,
    payload,
    action_id
})

export const count = (action_id, loading = true) => dispatch => {
    if(loading) {
        dispatch(changeLoading({ open: true }))
    }
    
    return HttpAuth.post('/actions/count/'+action_id)
            .then(res => {
                if(typeof res !== 'undefined') {
                    dispatch(countResponse(res.data, action_id))
                    if(!res.data.loading && !loading) {
                        dispatch(loadingResponse(res.data.action))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
            .catch(error => {
                dispatch( changeLoading({ open: false }) );
        
                if(typeof error.response !== 'undefined') {
                    if(error.response.status === 400) {
                        if(typeof error.response.data === 'object'){
                            if(typeof error.response.data.error_code !== undefined) {
                                dispatch(changeVerifySms({
                                    open: true,
                                    screen_id: 'actions.count.delete.reset.restore'
                                }))
                                
                                return false
                            }
                            
                            if(typeof error.response.data.error !== undefined) {
                                if(typeof error.response.data.error === 'string'){
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: error.response.data.error
                                    }))
                                }
                            }
    
                            if(typeof error.response.data.class !== undefined) {
                                dispatch(changeNotify({
                                    open: true,
                                    msg: error.response.data.msg,
                                    class: error.response.data.class
                                }))
                                dispatch(success(true))
                            }
                        }
                    }
                }
            })
}

export const total = (action_id, loading = true) => dispatch => {
    if(loading) {
        dispatch(changeLoading({ open: true }))
    }
    
    return HttpAuth.post('/actions/total/'+action_id)
            .then(res => {
                if(typeof res !== 'undefined') {
                    dispatch(countResponse(res.data, action_id))
                    if(!res.data.loading && !loading) {
                        dispatch(loadingResponse(res.data.action))
                    }
                }
                dispatch(changeLoading({ open: false }))
            })
}

// REPORTS

export const reports = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Gerando relatório...'
    }))
    return HttpAuth.get('/actions/reports/'+ id)
        .then((res) => {
            if (res.status != 200) throw new Error('Erro na resposta');

            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))

            if(res.status === 200) {
                const form = document.createElement('form');
                const secureUrl = res.data.url.replace('http:', 'https:');
                const urlObj = new URL(secureUrl)
                form.action = urlObj.origin + urlObj.pathname;
                form.method = 'GET';

                form.style.display = 'none';

                urlObj.searchParams.forEach((value, key) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
            }
        })
        .catch((error) => {
            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            dispatch(changeNotify({
                open: true,
                msg: 'Erro ao baixar o relatório.',
                class: 'error'
            }))
        });
}

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/actions?'+ new URLSearchParams(query))
            .then(res =>  {
                if(typeof res !== 'undefined') {
                    dispatch(indexResponse(res.data, isLoadMore))
                }
            })
}

// ENCERRADAS

export const closedResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const closed = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/actions/closed?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(closedResponse(res.data, isLoadMore)))
}

// LIXEIRA

export const trashResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const trash = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/actions/trash?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(closedResponse(res.data, isLoadMore)))
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/actions/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}